import { fetchByProvider } from "@next-core/runtime";
const cacheMap = new Map();
function isObj(v) {
  return typeof v === "object" && v !== null && !Array.isArray(v);
}
function isString(v) {
  return typeof v === "string";
}
function buildSortedCacheKey(provider) {
  const sortObj = obj => Object.keys(obj).sort().map(k => ({
    [k]: obj[k]
  }));
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  try {
    const sortedArgs = isObj(args) ? sortObj(args) : args.map(arg => isString(arg) ? arg : sortObj(arg));
    return JSON.stringify({
      provider,
      args: sortedArgs
    });
  } catch (e) {
    return JSON.stringify({
      provider,
      args
    });
  }
}
export default async function fetch(provider, cache, args) {
  let promise;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const cacheKey = buildSortedCacheKey(provider, ...args);
  !cache && cacheMap.has(cacheKey) && cacheMap.delete(cacheKey);
  if (cacheMap.has(cacheKey)) {
    promise = cacheMap.get(cacheKey);
  } else {
    promise = (() => {
      return fetchByProvider(provider, args, {
        cache: cache ? "default" : "reload"
      });
    })();
    cache && cacheMap.set(cacheKey, promise);
  }
  return promise;
}
//# sourceMappingURL=fetch.js.map